import React, { useEffect } from "react";

export default function Scroll(props) {
  const { children } = props;
  useEffect(() => {
    document.getElementById("main")?.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return <>{children}</>;
}
